import { useAtomValue } from "jotai";
import { notEmpty } from "../../../utils/not-empty";
import { multiformatAtom } from "../store/multiformat-atom";

import type { UseApiLoaderResponse } from "../../../server/api/hooks/use-api-loader";
import type { Multiformat } from "../store/types";

export const usePrompts = (): UseApiLoaderResponse<Record<string, string[]> | null> => {
  const { loading, error, data, reload } = useAtomValue(multiformatAtom);

  if (loading) return { loading, error, data: null, reload };
  if (error || !data) return { loading, error, data: null, reload };

  const prompts = data.content_types.reduce(
    (acc: Record<string, string[]>, c: Multiformat["content_types"][number]) => {
      const promptsForContentType =
        c.example_prompts
          ?.split(",")
          .map((prompt) => prompt.trim())
          .filter(notEmpty) ?? [];

      if (promptsForContentType.length > 0 && c.name) {
        return { ...acc, [c.name]: promptsForContentType };
      }
      return acc;
    },
    {},
  );

  return { loading, error, data: prompts, reload };
};
